import { render, staticRenderFns } from "./BatchRemovePhone.vue?vue&type=template&id=98eb9e90"
import script from "./BatchRemovePhone.vue?vue&type=script&lang=ts"
export * from "./BatchRemovePhone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports